import { render, staticRenderFns } from "./KoioteToolbar.vue?vue&type=template&id=8c2eea88&lang=true"
import script from "./KoioteToolbar.vue?vue&type=script&lang=js"
export * from "./KoioteToolbar.vue?vue&type=script&lang=js"
import style0 from "./KoioteToolbar.vue?vue&type=style&index=0&id=8c2eea88&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports